export default __webpack_public_path__ + "static/media/landing_page_bim_review_and_collab.b035ede6.gif";